// extracted by mini-css-extract-plugin
export default {"container":"textarea_container__vJp7e"};